/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.209.1-v202610071147-CD
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import type { SeeqRequestOverrides, SeeqErrorData } from '../variables';
import { getRuntime } from '../variables';
import type { AxiosPromise, AxiosError } from 'axios';
import { useMutation, useQuery, type UseMutationOptions, type UseMutationResult, type UseQueryOptions, type UseQueryResult } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import type * as models from '../model/models';

export class sqSCIMApiClass {
 
   constructor() {}

  /**
   * @summary Generate a new SCIM authentication token for the specified datasource
   * @param {string} datasourceClass - The datasource class of the user&#x27;s directory
   * @param {string} datasourceId - The datasource ID of the user&#x27;s directory
  */
  public generateToken(
    body: models.ScimTokenInputV1,
    {
      datasourceClass,
      datasourceId
    } : {
      datasourceClass: string,
      datasourceId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (datasourceClass === null || datasourceClass === undefined) {
      throw new Error("'datasourceClass' parameter required");
    }

    if (datasourceId === null || datasourceId === undefined) {
      throw new Error("'datasourceId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/scim/${encodeURIComponent(String(datasourceClass))}/${encodeURIComponent(String(datasourceId))}/token`
      .replace('{datasourceClass}', encodeURIComponent(String(datasourceClass)))
      .replace('{datasourceId}', encodeURIComponent(String(datasourceId)));
    const urlTemplate = `${baseUrl}/scim/{datasourceClass}/{datasourceId}/token`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.ScimTokenOutputV1>;
  }

  /**
   * @summary Retrieve the SCIM authentication token expiration information for the specified datasource
   * @param {string} datasourceClass - The datasource class of the user&#x27;s directory
   * @param {string} datasourceId - The datasource ID of the user&#x27;s directory
  */
  public getToken(
    {
      datasourceClass,
      datasourceId
    } : {
      datasourceClass: string,
      datasourceId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (datasourceClass === null || datasourceClass === undefined) {
      throw new Error("'datasourceClass' parameter required");
    }

    if (datasourceId === null || datasourceId === undefined) {
      throw new Error("'datasourceId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/scim/${encodeURIComponent(String(datasourceClass))}/${encodeURIComponent(String(datasourceId))}/token`
      .replace('{datasourceClass}', encodeURIComponent(String(datasourceClass)))
      .replace('{datasourceId}', encodeURIComponent(String(datasourceId)));
    const urlTemplate = `${baseUrl}/scim/{datasourceClass}/{datasourceId}/token`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.ScimTokenOutputV1>;
  }

  /**
   * @summary Invalidates all SCIM tokens for the specified datasource
   * @param {string} datasourceClass - The datasource class of the user&#x27;s directory
   * @param {string} datasourceId - The datasource ID of the user&#x27;s directory
  */
  public invalidateToken(
    {
      datasourceClass,
      datasourceId
    } : {
      datasourceClass: string,
      datasourceId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (datasourceClass === null || datasourceClass === undefined) {
      throw new Error("'datasourceClass' parameter required");
    }

    if (datasourceId === null || datasourceId === undefined) {
      throw new Error("'datasourceId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/scim/${encodeURIComponent(String(datasourceClass))}/${encodeURIComponent(String(datasourceId))}/token`
      .replace('{datasourceClass}', encodeURIComponent(String(datasourceClass)))
      .replace('{datasourceId}', encodeURIComponent(String(datasourceId)));
    const urlTemplate = `${baseUrl}/scim/{datasourceClass}/{datasourceId}/token`;



    return axiosInstance.request({
      method: 'delete',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<{}>;
  }

}


export const sqSCIMApi = new sqSCIMApiClass();

export type sqSCIMApiEndpoints = {
  'generateToken': {
    method: 'post';
    path: '/scim/${encodeURIComponent(String(datasourceClass))}/${encodeURIComponent(String(datasourceId))}/token';
    response: models.ScimTokenOutputV1;
  };
  'getToken': {
    method: 'get';
    path: '/scim/${encodeURIComponent(String(datasourceClass))}/${encodeURIComponent(String(datasourceId))}/token';
    response: models.ScimTokenOutputV1;
  };
  'invalidateToken': {
    method: 'delete';
    path: '/scim/${encodeURIComponent(String(datasourceClass))}/${encodeURIComponent(String(datasourceId))}/token';
    response: {};
  };
};

type ApiGenerateTokenResponse = models.ScimTokenOutputV1;
type ApigenerateTokenMutationParams = Parameters<typeof sqSCIMApi.generateToken> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqSCIMApi.generateToken>;

export function useApiGenerateTokenMutation(
  options?: Omit<UseMutationOptions<ApiGenerateTokenResponse, AxiosError<SeeqErrorData>,
    ApigenerateTokenMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiGenerateTokenResponse, AxiosError<SeeqErrorData>,
  ApigenerateTokenMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApigenerateTokenMutationParams) =>
      sqSCIMApi.generateToken(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiGetTokenResponse = models.ScimTokenOutputV1;
export function GetTokenQueryKey(
  params: Parameters<typeof sqSCIMApi.getToken>[0],
) {
  return ['sqSCIMApi', 'getToken', params] as const;
}

export function useApiGetTokenQuery(
  params: Parameters<typeof sqSCIMApi.getToken>[0],
  options?: Omit<UseQueryOptions<ApiGetTokenResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetTokenResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetTokenQueryKey(params),
    queryFn: () =>
      sqSCIMApi.getToken(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiInvalidateTokenResponse = {};
type ApiinvalidateTokenMutationParams = Parameters<typeof sqSCIMApi.invalidateToken> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqSCIMApi.invalidateToken>;

export function useApiInvalidateTokenMutation(
  options?: Omit<UseMutationOptions<ApiInvalidateTokenResponse, AxiosError<SeeqErrorData>,
    ApiinvalidateTokenMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiInvalidateTokenResponse, AxiosError<SeeqErrorData>,
  ApiinvalidateTokenMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApiinvalidateTokenMutationParams) =>
      sqSCIMApi.invalidateToken(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
